var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    ref: "timesheetgantt",
    staticClass: "w-100",
    class: this.colorClass,
    attrs: { id: "gantt_test" },
    on: {
      dblclick: function ($event) {
        return _vm.$emit("dblClickEmptyArea")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }